<script>
import McGraphqlEditableTable from '@/components/McGraphqlEditableTable'
import {
  GET_OPERATIONAL_NOTES,
  OPERATIONAL_NOTES_MUTATION_CREATE,
  OPERATIONAL_NOTES_MUTATION_UPDATE,
  OPERATIONAL_NOTES_MUTATION_DELETE,
} from '@/services/api/setting/fleet/operationalNotes'

export default {
  components: {
    McGraphqlEditableTable,
  },
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: [],
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'text',
          label: this.$t('setting.list.fleetSetting.operationalNotes'),
          placeholder: `${this.$t('global.form.enter')} ${this.$t('setting.list.fleetSetting.operationalNotes')}`,
          thClass: 'mc-table--50',
          isEditable: true,
          isSortable: true,
          validation: [['required']],
          'validation-messages': {
            required: `${this.$t('setting.list.fleetSetting.operationalNotes')} ${this.$t('global.validation.required')}`,
          },
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          let result = []
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_OPERATIONAL_NOTES,
            variables: {
              filter,
            },
          })
          let self = this

          result = res.data.operationalNotes.operationalNotes
          result.data.forEach((item, index) => {
            if (item.companyId == 1 || item.hasRelation) {
              result.data[index].disableCheckbox = true
              result.data[index].isShowEdit = false
            }
          })
          self.data = result.data

          return result
        },
        store: async (data) => {
          const res = await this.$apollo.mutate({
            mutation: OPERATIONAL_NOTES_MUTATION_CREATE,
            variables: {
              input: {
                text: data.text,
              },
            },
          })
          if (
            res.data.createOperationalNote.message.toLowerCase().includes('already registered')
          ) {
            this.$mcToast.warning(this.$t('setting.operationalNotes.message.hasBeenUsed', { object: this.$t('setting.list.fleetSetting.operationalNotes')}))
            return
          }
          let newData = res.data.createOperationalNote.operationalNote
          newData.hasRelation = false
          this.data.push(newData)

          return newData
        },
        update: async (_, oldData, newData) => {
          if (!newData?.text) {
            this.$mcToast.warning(this.$t('setting.message.noChangesWereMade'))
            return
          }

          const res = await this.$apollo.mutate({
            mutation: OPERATIONAL_NOTES_MUTATION_UPDATE,
            variables: {
              input: {
                oldValue: oldData.text,
                newValue: newData.text,
              },
            },
          })
          if (
            res.data.updateOperationalNote.message.toLowerCase().includes('already registered')
          ) {
            this.$mcToast.warning(this.$t('setting.operationalNotes.message.hasBeenUsed', { object: this.$t('setting.list.fleetSetting.operationalNotes')}))
            return
          }

          const updateData = res.data.updateOperationalNote.operationalNote
          updateData.hasRelation = oldData.hasRelation
          if (updateData.companyId == 1 || updateData.hasRelation) {
            updateData.disableCheckbox = true
          }

          return updateData
        },
        delete: async (text) => {
          const res = await this.$apollo.mutate({
            mutation: OPERATIONAL_NOTES_MUTATION_DELETE,
            variables: {
              input: {
                text,
              },
            },
          })

          return res.data.deleteOperationalNote.isSuccessful
        },
      }
    },
  },
}
</script>

<template>
  <!-- Operational Notes -->
  <b-tab class="border-0" @click="$store.commit('setting/SET_STATUS', status)">
    <template #title>
      <span class="d-sm-inline-block">{{ $t('setting.list.fleetSetting.operationalNotes') }}</span>
    </template>

    <!-- Table -->
    <div class="table-responsive my-3">
      <McGraphqlEditableTable
        :fields="fields"
        :apiClient="query"
        trackBy="text"
        :isPredefined="true"
        :searchable="true"
        :idIsString="true"
      />
    </div>
  </b-tab>
</template>
